// extracted by mini-css-extract-plugin
module.exports = {"action-tick":"actionTickWithGradient_action-tick__3pyiT"};